const data = {
  id: 1,
  title: 'Listen and tick T or F.',
  subTitle: 'Nghe và chọn đúng hoặc sai.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/402770fb-c298-43c8-87b0-3808a33ac1de.mp3',
  imageUrl: '',
  questionText: '',
  question: '',
  answers: [
    { answer: 'Hoa lives with her family in To Hien Thanh street.', isCorrect: true },
    { answer: 'Hoa rides a bike to school every day.', isCorrect: false },
  ],

};

export default data;
